export const isProd = import.meta.env.PROD

export function productionLoginUsers(): Array<{
  email: string
  password: string
  tenantId: string
  role: 'admin' | 'viewer'
}> {
  const email = (import.meta.env.VITE_DASHBOARD_LOGIN_EMAIL as string | undefined)?.trim()
  const password = (import.meta.env.VITE_DASHBOARD_LOGIN_PASSWORD as string | undefined)?.trim()
  if (!email || !password) return []
  return [{ email, password, tenantId: 'ordermage', role: 'admin' }]
}
